export const filterValidStrings = (items?: string[] | null): string[] =>
  items?.filter((item): item is string => Boolean(item.trim())) ?? [];

/** Prefers the API's canonical `phoneNumbers` array; falls back to legacy `phoneNumber`. */
export const resolveMerchantPhoneDisplay = (
  merchantDetails:
    | {
        phoneNumber?: string | null;
        phoneNumbers?: string[] | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const fromArray = filterValidStrings(merchantDetails?.phoneNumbers);

  if (fromArray.length > 0) {
    const joined = fromArray.join('; ');

    return { text: joined, copy: joined };
  }

  const single = merchantDetails?.phoneNumber?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  return { text: null, copy: '' };
};

/** Prefers the API's canonical `emailAddresses` array; falls back to legacy `email`. */
export const resolveMerchantEmailDisplay = (
  merchantDetails:
    | {
        email?: string | null;
        emailAddresses?: string[] | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const fromArray = filterValidStrings(merchantDetails?.emailAddresses);

  if (fromArray.length > 0) {
    const joined = fromArray.join('; ');

    return { text: joined, copy: joined };
  }

  const single = merchantDetails?.email?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  return { text: null, copy: '' };
};

/** Prefers the API's canonical `physicalAddresses` array; falls back to legacy `address` / `physicalAddress`. */
export const resolveMerchantAddressDisplay = (
  merchantDetails:
    | {
        address?: string | null;
        physicalAddresses?: string[] | null;
        physicalAddress?: string | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const fromArray = filterValidStrings(merchantDetails?.physicalAddresses);

  if (fromArray.length > 0) {
    const joined = fromArray.join('; ');

    return { text: joined, copy: joined };
  }

  const single = merchantDetails?.address?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  const legacy = merchantDetails?.physicalAddress?.trim();

  if (legacy) {
    return { text: legacy, copy: legacy };
  }

  return { text: null, copy: '' };
};
